(ns frontend.ui.component.lp-portal.landing-page.reports-menu-desktop.style
  (:require
   [frontend.ui.style.theme.core :as theme]
   [garden.util :refer [space-join]]
   [garden.units :refer [px]]))

(defn section-title
  []
  (with-meta {:font-size   :24px
              :font-weight :700
              :color       (theme/color [:text :primary :color])
              :white-space :nowrap
              :align-self  :start}
             {:media
              {{:screen :only :max-width (px 1100)}
               {:gap :20px}}}))

(defn container
  []
  (with-meta {:display     :flex
              :flex        :1
              :align-items :center
              :gap         :20px
              :margin      "50px 0 0"}
             {:media
              {{:screen :only :max-width (px 900)}
               {:flex-direction :column}}}))

(defn menu-items-container
  []
  (with-meta
    {:display :flex
     :flex    :1
     :justify-content :center
     :gap     :60px}
    {}))

(defn menu-item
  []
  {:text-transform :uppercase
   :font-size      :12px
   :font-weight    :bold
   :letter-spacing :2.2px
   :color          (theme/color [:link :main :color])
   :height         :53px
   :display        :flex
   :align-items    :center
   :position       :relative
   :user-select    :none
   :cursor         :pointer
   :white-space    :nowrap})

(defn caret
  []
  {:background  (theme/color [:container-bgr :primary :bg])
   :border-left (space-join ["1px"
                             "solid"
                             (theme/color [:general-border :caret])])
   :border-top  (space-join ["1px"
                             "solid"
                             (theme/color [:general-border :caret])])
   :transform   "rotate(45deg)"
   :width       :15px
   :height      :15px
   :position    :absolute
   :bottom      :-8px
   :left        "calc(50% - 15px / 2)"
   :z-index     :1})
